<template>
  <div class="bg-wrap">
    <div class="step1">
      <div class="box">
        <div class="tit">座位号：1</div>
        <div class="logo"><a href="javascript:void(0)" class=""><img src="@/assets/images/step/logo.jpg"></a></div>
        <div class="step-con">
          <ul>
            <li><span>准考证号：</span><input type="text"  value="11111111111" v-model="zkzID"></li>
            <li><span>证 件 号：</span><input type="text"  value="111111111111111111" v-model="personID"></li>
          </ul>
          <div class="btn">
            <a href="javascript:void(0);" @click="goNext" class="a1"><img src="@/assets/images/step/login-btn.gif"></a>
            <a href="javascript:void(0);"><img src="@/assets/images/step/reset-btn.gif"></a>
          </div>
        </div>
        <span class="tip">说明：请使用准考证号：11111111111，证件号：111111111111111111</span>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { setPageTitle, isEmptyObject, parseNumber } from "@/utils"

  export default {
    name: 'Step1',
    components: {},
    computed: {
      ...mapGetters([
        'siteData'
      ])
    },
    data() {
      return {
        courseName: '',
        siteCourseID: '',
        courseID: '',
        zkzID: '11111111111',
        personID:'111111111111111111'
      }
    },
    async mounted() {
      const { flag } = this.$route.params
      let _flag = flag === 'paidExam' ? '' : flag
      const { courseID, siteCourseID } = this.$route.query
      const { majorID } = this.$categoryInfo
      this.courseID = courseID
      this.siteCourseID = parseNumber(siteCourseID)

      if (isEmptyObject(this.siteData)) {
        let params = {
          flag: _flag,
          majorID: majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch('getCurrentSiteInfo', params)
          .then(res => {
            const { siteCourseName } = res.currentCourse
            this.courseName = siteCourseName
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      } else {
        this.courseName = this.siteData.currentCourse.siteCourseName
      }
      document.title = setPageTitle(this.courseName)
    },
    methods: {
      goNext() {
        let checkNumber1 = this.zkzID.trim()
        let checkNumber2 = this.personID.trim()
        let reg = /[\u4E00-\u9FA5]/g
        if (reg.test(checkNumber1) || reg.test(checkNumber2)) {
          alert("请输入数字！")
          return
        }
        if (checkNumber1 == null || checkNumber1 == "") {
          alert("请输入准考证号！");
        } else if(checkNumber2 == null || checkNumber2 == ""){
          alert("请输入证件号！");
        }else if (checkNumber1=='11111111111' && checkNumber2=='111111111111111111') {
          this.$router.push({
            path: `step2`,
            query: {
              siteCourseID: this.siteCourseID,
              courseID: this.courseID,
              zkzID: this.zkzID
            }
          })
        } else {
          alert('准考证号的错误!')
        }
      }
    }
  }
</script>

